<template>
  <div>
    <div v-for="(product, key) in data" :style="key !== 0 ? 'border-top: 2px solid #eaeaea;' : ''" class="textfield"
         style=" padding: 2px 0"
         v-html="product"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'tablefield-texts',
  props: ['data', 'config'],
}
</script>



// WEBPACK FOOTER //
// FieldTexts.vue?1580b9ce